@if (auth.user$ | async; as user) {
<div class="badge">
    <kendo-dropdownbutton imageUrl="{{user.picture!}}" [data]="[{text:'Logout'}]" (itemClick)="this.logout()" class="badge-button">{{user.name}}</kendo-dropdownbutton>
</div>
}
@if ((auth.isAuthenticated$ | async) === false) {   
    <button kendoButton [themeColor]="'primary'" (click)="loginWithRedirect()">
        Log in
    </button>
}
